import { createSelector } from 'reselect';

const getMoments = state => {
  return state.kioskReducer.portalMoments;
}

const getSelectedPrintMomentIds = state => {
  return state.kioskReducer.selectedPrintMomentIds;
}

const getSettings = state => {
  return state.kioskReducer.settings;
}

const getLocale = state => {
  return state.messagesReducer.locale;
}

export const getLocaleSettings = createSelector(
  getSettings,
  getLocale,
  (settings, locale) => {
    return settings.locales.find(l => l.locale === locale);
  }
);

export const getEnabledLocales = createSelector(
  getSettings,
  settings => {
    return settings.locales.filter(locale => locale.enabled);
  }
);


export const getSelectedPrintMoments = createSelector(
  getSelectedPrintMomentIds,
  getMoments,
  (selectedPrintMomentIds, portalMoments) => {
    return selectedPrintMomentIds.map(id => portalMoments.byId[id]);
  }
);

export const getPortalMoments = createSelector(
  getMoments,
  portalMoments => portalMoments.allIds.map(id => portalMoments.byId[id])
);

